"use client";
import { css as i } from "@emotion/react";
import { COLORS as f } from "../../../tokens/colors/Colors.js";
import { SIZES as r } from "../../../tokens/sizes/Sizes.js";
const l = (s) => {
  const { color: o, offset: t = r.s02, radius: e } = s ?? {};
  return i`
		border-radius: ${e};
		outline: ${r.s02} solid ${o || f.brand};
		outline-offset: ${t};
	`;
};
export {
  l as focusOutline
};
